import { ChangeEmailDialogComponent } from './../../dialogs/change-email-dialog/change-email-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './../../services/auth.service';
import { ErrorResponse } from './../../models/error.model';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from './../../services/utils.service';
import { OfficesService } from './../../services/offices.service';
import { Office } from './../../models/office.model';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from './../generics/data-table/data-table.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';

@Component({
    selector: 'app-offices',
    templateUrl: './offices.component.html',
    styleUrls: ['./offices.component.scss']
})
export class OfficesComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate!: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Número oficina', sortable: true, prop: 'sucursal' },
        { name: 'Nombre', sortable: true, prop: 'nombre' },
        { name: 'E-Mail', sortable: true, prop: 'email', type: 'email' },
        { name: 'CUIT', sortable: true, prop: 'cuit', type: 'cuit' },
        { name: 'Responsable', parseValue: (value: Office) => value.nombreResponsable + ' ' + value.apellidoResponsable },
        { name: 'Teléfono', prop: 'telefonoFijo', type: 'phone' },
        { name: 'Celular', prop: 'celular', type: 'phone' },
        { name: '', width: '140px' }
    ];

    sortConfiguration?: SortConfiguration;

    offices!: Office[];

    filters: CustomTableFilter[] = [
        { key: 'sucursal', description: 'Número de oficina', type: 'STRING' },
        { key: 'nombre', description: 'Nombre', type: 'STRING' },
        { key: 'email', description: 'Email', type: 'STRING' },
        { key: 'cuit', description: 'CUIT', type: 'STRING' },
        { key: 'responsable-nombre', description: 'Nombre del responsable', type: 'STRING' },
        { key: 'responsable-apellido', description: 'Apellido del responsable', type: 'STRING' },
    ];
    filterValues: any = {};

    constructor(
        private officesService: OfficesService,
        private authService: AuthService,
        private dialog: MatDialog,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === '')!.template = this.buttonsColumnTeplate;
        this.getOffices();
    }

    getOffices() {
        this.officesService.getOffices(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
            .subscribe(response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.offices = response.body ?? [];
            }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener oficinas', error.error?.descripcion ?? ''));
    }

    updateOffices(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getOffices();
    }

    updateSort(event: SortConfiguration | undefined) {
        this.sortConfiguration = event;
        this.getOffices();
    }

    deleteOffice(office: Office) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.officesService.deleteOffice(office.id!).subscribe(_ => {
                    this.utilsService.alert('Oficina borrada correctamente', `Se ha eliminado la oficina número ${office.sucursal} con email ${office.email} de la plataforma.`);
                    this.getOffices();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al borrar oficina', error.error?.descripcion ?? ''));
            }
        });
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getOffices();
    }

    resetUserPassword(office: Office) {
        const alert = this.utilsService.confirm('¿Está seguro?', 'Se enviará un email al dueño de la cuenta para generar una nueva contraseña, esta acción no se puede deshacer.');
        alert.afterClosed().subscribe(result => {
            if (result) {
                this.authService.requestRecovery(office.email, 'OFICINA').subscribe({
                    next: _ => this.utilsService.alert('Contraseña regenerada correctamente', 'Se ha enviado un email al email registrado con la nueva clave.'),
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al regenerar clave', error.error?.descripcion ?? '')
                });
            }
        });
    }

    changeEmail(office: Office) {
        this.dialog.open(ChangeEmailDialogComponent, { data: { email: office.email } })
            .afterClosed().subscribe(result => {
                if (result) {
                    this.getOffices();
                }
            });
    }
}
